/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Event_Number_AriaInputs */

const en_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Number`)
};

const fr_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero d'evenement`)
};

const de_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisnummer`)
};

const it_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero dell'evento`)
};

const ru_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Номер события`)
};

const es_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de evento`)
};

const zh_cn2_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件编号`)
};

const ja_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント番号`)
};

const hi_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना संख्या`)
};

const pt_pt2_video_export_preview_event_number_aria = /** @type {(inputs: Video_Export_Preview_Event_Number_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número do evento`)
};

/**
* | output |
* | --- |
* | "Event Number" |
*
* @param {Video_Export_Preview_Event_Number_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_event_number_aria = /** @type {((inputs?: Video_Export_Preview_Event_Number_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Event_Number_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_event_number_aria(inputs)
	if (locale === "de") return de_video_export_preview_event_number_aria(inputs)
	if (locale === "it") return it_video_export_preview_event_number_aria(inputs)
	if (locale === "ru") return ru_video_export_preview_event_number_aria(inputs)
	if (locale === "es") return es_video_export_preview_event_number_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_event_number_aria(inputs)
	if (locale === "ja") return ja_video_export_preview_event_number_aria(inputs)
	if (locale === "hi") return hi_video_export_preview_event_number_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_event_number_aria(inputs)
	return en_video_export_preview_event_number_aria(inputs)
});